import React, { useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';
import './SignInPage.css';

function SignInPage() {
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUsernamePasswordLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Clear ALL previous session storage data first
      sessionStorage.clear();
      
      // Check for original demo user first (shows everything)
      if (username === 'demouser' && password === 'Ryder@1933') {
        // Store a simple auth flag in sessionStorage
        sessionStorage.setItem('simpleAuth', 'true');
        sessionStorage.setItem('simpleAuthUser', 'demouser');
        sessionStorage.setItem('isAdminView', 'true'); // Flag to show all employees
        
        // Redirect to dashboard
        setTimeout(() => {
          navigate('/dashboard');
          setLoading(false);
        }, 500);
        return;
      }

      // Otherwise, authenticate against manager ID in Employees table
      const response = await fetch('http://localhost:4000/api/auth/manager', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Store authentication info in sessionStorage
        sessionStorage.setItem('simpleAuth', 'true');
        sessionStorage.setItem('simpleAuthUser', data.user.managerId);
        sessionStorage.setItem('managerName', data.user.name);
        sessionStorage.setItem('managerInfo', JSON.stringify(data.user));
        // DO NOT set isAdminView for manager logins
        
        // Redirect to dashboard
        setTimeout(() => {
          navigate('/dashboard');
          setLoading(false);
        }, 500);
      } else {
        setError(data.message || 'Invalid manager credentials. Please enter a valid Manager ID.');
        setLoading(false);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Unable to connect to the server. Please try again.');
      setLoading(false);
    }
  };

  const handleOktaLogin = () => {
    setLoading(true);
    oktaAuth.signInWithRedirect();
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="signin-header">
          <img src="/ryder.png" alt="Ryder Logo" className="signin-logo" />
          <h1>Welcome Back</h1>
          <p>Sign in to access your dashboard</p>
        </div>

        <div className="signin-methods">
          {/* Username/Password Form */}
          <form onSubmit={handleUsernamePasswordLogin} className="signin-form">
            <h2>Sign in with Credentials</h2>
            
            {error && <div className="error-message">{error}</div>}
            
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                disabled={loading}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                disabled={loading}
                required
              />
            </div>

            <button 
              type="submit" 
              className="signin-button primary"
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          {/* Divider */}
          <div className="signin-divider">
            <span>OR</span>
          </div>

          {/* Okta SSO Option */}
          <div className="okta-signin">
            <h2>Sign in with Okta</h2>
            <p className="okta-description">
              Use your organization's Okta account for single sign-on
            </p>
            <button 
              onClick={handleOktaLogin}
              className="signin-button okta"
              disabled={loading}
            >
              <svg 
                viewBox="0 0 24 24" 
                width="20" 
                height="20" 
                className="okta-icon"
              >
                <path 
                  fill="currentColor" 
                  d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
                />
              </svg>
              Continue with Okta SSO
            </button>
          </div>
        </div>

        <div className="signin-footer">
          <p>© 2025 Ryder System, Inc. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default SignInPage;
